module.exports = __webpack_public_path__ + "static/media/sharechat-2.7a9ec329.webp";